export default __webpack_public_path__ + "static/media/COVID-Icons-3.a9cf1a91.svg";